<template>
  <div class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch">
    <input
      v-model="model.search_value"
      type="text"
      ref="input_text"
      :placeholder="placeholder"
      @keypress.enter="onEnter"
      :readonly="disabled"
      :class="{ 'ts-cursor-not-allowed ts-bg-gray-200': disabled }"
      class="ts-px-2 ts-py-2 ts-placeholder-blueGray-300 ts-text-blueGray-600 ts-relative ts-border ts-border-gray-300 ts-bg-white ts-rounded ts-text-sm ts-border-1 ts-shadow ts-outline-none focus:ts-outline-none focus:ts-ring ts-w-full ts-pr-10"
    />
    <span
      class=" hover:ts-text-blue-600
				ts-cursor-pointer 
				ts-z-10 
				ts-h-full 
				ts-leading-snug 
				ts-font-normal 
				ts-absolute 
				ts-text-center 
				ts-text-blueGray-300 
				ts-bg-transparent 
				ts-rounded 
				ts-text-base 
				ts-items-center 
				ts-justify-center 
				ts-w-8 ts-right-0 
				ts-pr-3 ts-py-3
			"
      @click.prevent="onEnter"
    >
      <i class="fas fa-search" v-if="!waiting"></i>
      <i class="fas fa-spinner d-inline-block spin" v-else></i>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    waiting: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object
    }
  },
  data () {
    return {
      model: {
        search_value: ''
      }
    }
  },
  mounted () {
    if (!this.allow_only_scan_on_transfer) {
      this.$refs.input_text.focus()
    }
  },
  created () {
    this.model = this.value
  },
  computed: {
    placeholder () {
      return this.$t('stockTransfer.serialNumberOrBacode')
    },
    allow_only_scan_on_transfer () {
      return this.$store.state.authUser.user.allow_only_scan_on_transfer
    }
  },
  methods: {
    onEnter () {
      this.$emit('onEnter')
    }
  }
}
</script>
